import {
  Button,
  Stack,
  ButtonProps,
  Link,
  LinkProps,
  Box,
  Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useContaxt } from "../context/Context";

const MotionButton = motion(Button);

export function ActionButton(props: any) {
  const { color } = useContaxt() as any;

  const [show, setShow] = useState(false);

  const { ml, ...rest } = props;

  return (
    <Stack
      px={0.5}
      py={0.5}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      borderRadius={"50vh"}
    >
      <a
        href={"https://calendly.com/webwerk-am-meer/beratungs-gespraech"}
        target={"_blank"}
        title="Termin vereinbaren"
      >
        <MotionButton
          ml={ml}
          h={"70px"}
          fontSize={"14px"}
          w={"300px"}
          textAlign={"center"}
          borderRadius={"50vh"}
          color={"white"}
          bg={color.buttonColor}
          _hover={{ bgColor: color.buttonColor }}
          textTransform={"uppercase"}
          letterSpacing={2}
          whileHover={{ y: -2 }}
          whileTap={{ y: 0, scale: 0.99 }}
          transition={{ type: "spring", stiffness: 380, damping: 26 }}
          boxShadow={"0 10px 26px rgba(0,0,0,0.22)"}
          _active={{ transform: "none" }}
          _focusVisible={{ boxShadow: `0 0 0 3px rgba(255,255,255,0.28)` }}
          {...rest}
        >
          <Flex align="center" justify="center" gap={3} w="100%">
            <Box w="32px" h="32px" position="relative" />
            <motion.span
              animate={{ x: show ? -4 : 0 }}
              transition={{ duration: 0.25 }}
              style={{ display: "inline-block" }}
            >
              Termin vereinbaren
            </motion.span>
            <Box w="32px" h="32px" position="relative" overflow="hidden">
              <AnimatePresence initial={false}>
                {show ? (
                  <motion.span
                    key="arrow"
                    style={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.2 }}
                  >
                    <MdKeyboardArrowRight size={32} />
                  </motion.span>
                ) : null}
              </AnimatePresence>
            </Box>
          </Flex>
        </MotionButton>
      </a>
    </Stack>
  );
}

export function ActionButtonV2(props: ButtonProps) {
  const { color } = useContaxt() as any;

  return (
    <MotionButton
      fontSize={"18px"}
      textAlign={"center"}
      borderRadius={"50vh"}
      color={"white"}
      bg={color.buttonColor}
      _hover={{ bgColor: color.buttonColor }}
      textTransform={"uppercase"}
      letterSpacing={2}
      whileHover={{ y: -2 }}
      whileTap={{ y: 0, scale: 0.99 }}
      transition={{ type: "spring", stiffness: 380, damping: 26 }}
      boxShadow={"0 10px 26px rgba(0,0,0,0.22)"}
      _active={{ transform: "none" }}
      _focusVisible={{ boxShadow: `0 0 0 3px rgba(255,255,255,0.28)` }}
      {...props}
    >
      Termin vereinbaren
    </MotionButton>
  );
}

export function ActionLink({ children, ...rest }: LinkProps) {
  return (
    <Link
      href={"https://calendly.com/webwerk-am-meer/beratungs-gespraech"}
      target={"_blank"}
      title="Termin vereinbaren"
      {...rest}
    >
      {children}
    </Link>
  );
}
